import React from 'react'
import TextField from './../../shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import SelectField from "../../shared/components/fields/selectField/SelectField";
import Alert from '../../shared/components/alerts/Alert';
import FormButtons from "../../shared/components/others/formButtons/FormButtons";
import { getDropdown } from "../utils/dropdownLists";
import DataTable from "../../shared/components/table/DataTable";
import UserHasPermission, {appModules, modulesActions} from '../../roles/components/UserHasPermission';
import IconButton from "../../shared/components/others/IconButton";
import addButton from "../../shared/img/add-button.svg";

const InterfacesForm = ({
    interfaceFormData: {
        interfaceIdentifier,
        name,
        dataType,
        historyConfiguration,
        historyMaxAge,
        unitType,
        category,
        interfaceType,
        lastReading,
        lastCommunication,
    },
    unitTypeList,
    associatedEntitiesList,
    categoryList,
    alert,
    editMode,
    createMode,
    viewMode,
    handleFieldChange,
    handleOnFieldBlur,
    handleSubmitClick,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
    handleAddButtonClicked
}) => {
    const entitiesColumns = [{
        Header: I18n.t("interfaces.associatedEntities.name"),
        accessor: "name",
        sortable: false
    }, {
        Header: I18n.t("interfaces.associatedEntities.type"),
        accessor: "type",
        sortable: false
    }];
    return <div>
        <div className="form-container">
            <div className="form">
                <Alert
                    {...alert}
                />
                <div className="header">
                    {buildHeader(createMode, editMode, viewMode)}
                </div>
                <div className="fields">
                    <div id="interface-fields-1" className="field-row">
                        <div className="row">
                            <TextField
                                value={interfaceIdentifier.value}
                                label={I18n.t("interfaces.form.interfaceIdentifier.label")}
                                handleFieldChange={value => handleFieldChange("interfaceIdentifier", value)}
                                handleFieldBlur={() => handleOnFieldBlur("interfaceIdentifier")}
                                themeName="form"
                                error={interfaceIdentifier.error}
                                disabled={viewMode || editMode}
                                width={4}
                            />
                            <TextField
                                value={name.value}
                                label={I18n.t("interfaces.form.name.label")}
                                handleFieldChange={value => handleFieldChange("name", value)}
                                handleFieldBlur={() => handleOnFieldBlur("name")}
                                themeName="form"
                                error={name.error}
                                disabled={viewMode}
                                width={4}
                            />
                        </div>
                        <div className="row">
                            <SelectField
                                handleFieldChange={value => handleFieldChange("dataType", value)}
                                value={dataType.value}
                                label={I18n.t("interfaces.form.dataType.label")}
                                options={getDropdown("dataType")}
                                error={dataType.error}
                                disabled={viewMode || editMode}
                                width={4}
                            />
                            <SelectField
                                value={historyConfiguration.value}
                                label={I18n.t("interfaces.form.historyConfiguration.label")}
                                handleFieldChange={value => handleFieldChange("historyConfiguration", value)}
                                options={getDropdown("historyConfiguration")}
                                error={historyConfiguration.error}
                                disabled={viewMode}
                                width={4}
                            />
                        </div>
                        <div className="row">
                            <TextField
                                value={historyMaxAge.value}
                                label={I18n.t("interfaces.form.historyMaxAge.label")}
                                handleFieldChange={value => handleFieldChange("historyMaxAge", value)}
                                handleFieldBlur={() => handleOnFieldBlur("historyMaxAge")}
                                themeName="form"
                                error={historyMaxAge.error}
                                disabled={viewMode}
                                width={4}
                                type="number"
                            />
                            <SelectField
                                handleFieldChange={value => handleFieldChange("unitType", value)}
                                value={unitType.value}
                                label={I18n.t("interfaces.form.unitType.label")}
                                options={unitTypeList}
                                error={unitType.error}
                                disabled={viewMode}
                                width={4}
                            />
                        </div>
                        <div className="row">
                            <SelectField
                                handleFieldChange={value => handleFieldChange("category", value)}
                                value={category.value}
                                label={I18n.t("interfaces.form.category.label")}
                                options={categoryList}
                                error={category.error}
                                disabled={viewMode || editMode}
                                width={4}
                            />

                            <SelectField
                                handleFieldChange={value => handleFieldChange("interfaceType", value)}
                                value={interfaceType.value}
                                label={I18n.t("interfaces.form.interfaceType.label")}
                                options={getDropdown("interfaceType")}
                                error={interfaceType.error}
                                disabled={viewMode || editMode}
                                width={4}
                            />
                        </div>

                        <div className="row">

                            {viewMode && (
                                <>
                                    <TextField
                                        value={lastReading.value}
                                        label={I18n.t("interfaces.form.lastReading.label").concat(
                                            unitType.value ?
                                                unitType.value.properties ?
                                                    unitType.value.properties.symbol ?
                                                        " in ".concat(unitType.value.properties.symbol) :
                                                        "" :
                                                    "" :
                                                ""
                                        )}
                                        handleFieldChange={value => handleFieldChange("lastReading", value)}
                                        handleFieldBlur={() => handleOnFieldBlur("lastReading")}
                                        themeName="form"
                                        error={lastReading.error}
                                        disabled={viewMode}
                                        width={4}
                                    />
                                    <TextField
                                        value={lastCommunication.value}
                                        label={I18n.t("interfaces.form.lastCommunication.label")}
                                        handleFieldChange={value => handleFieldChange("lastCommunication", value)}
                                        handleFieldBlur={() => handleOnFieldBlur("lastCommunication")}
                                        themeName="form"
                                        error={lastCommunication.error}
                                        disabled={viewMode}
                                        width={4}
                                    />
                                </>
                            )}
                        </div>


                    </div>
                </div>
                {viewMode && (
                    <div>
                        <div className="header header-with-add-button">
                            {I18n.t("interfaces.associatedEntities.header")}
                            <div>
                                <UserHasPermission
                                    appModule={appModules.INTERFACE}
                                    action={modulesActions.CREATE}
                                >
                                    <div style={{ marginLeft: 'auto', marginRight: 0, display: 'flex' }} >
                                        <IconButton
                                            alt="add"
                                            image={addButton}
                                            handleIconClick={handleAddButtonClicked}
                                        />
                                    </div>
                                </UserHasPermission>
                            </div>
                        </div>
                        <div>
                            <DataTable
                                data={associatedEntitiesList ? associatedEntitiesList : []}
                                columns={entitiesColumns}
                                hasHeader={false}
                                suppressBorders={true}
                                pageSize={3}
                            />
                        </div>
                    </div>
                )}
                {(createMode || editMode) &&
                    <div className="buttons">
                        <button
                            className=" mt-3 btn btn-primary"
                            onClick={handleSubmitClick}
                        >
                            {I18n.t("forms.save")}
                        </button>
                    </div>}
            </div>
            <div className="form-options">
                <FormButtons
                    editMode={editMode}
                    viewMode={viewMode}
                    handleBackClick={handleBackClick}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                    appModule={appModules.INTERFACE}
                />
            </div>
        </div>
    </div>
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("interfaces.form.headers.create") :
        editMode ?
            I18n.t("interfaces.form.headers.edit") :
            I18n.t("interfaces.form.headers.view");
}

export default InterfacesForm;